import { render, staticRenderFns } from "./DividedItems.vue?vue&type=template&id=6406749a&"
import script from "./DividedItems.vue?vue&type=script&lang=js&"
export * from "./DividedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports